import { render, staticRenderFns } from "./Australian.vue?vue&type=template&id=86147cec&"
import script from "./Australian.vue?vue&type=script&lang=js&"
export * from "./Australian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports